import { Fragment, useContext } from "react";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import { FC } from "react";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  padding: 0
};

type QuestionSaveAlertProps = {
  isOpen: boolean;
  handleClose: any;
  width?: number;
  submitAction: () => void;
};

const QuestionSaveAlert: FC<QuestionSaveAlertProps> = ({
  isOpen,
  handleClose,
  submitAction,
  width = 600
}): JSX.Element => {
  if (!isOpen) return <></>;
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={isOpen}
      onClose={() => {
        handleClose();
      }}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500
        }
      }}
    >
      <Fade in={isOpen} className="p-0">
        <Box sx={[style, { width }]}>
          <Box className="bg-[#2563eb] py-1">
            <Typography
              id="transition-modal-title"
              variant="h6"
              component="h2"
              className="text-white text-center"
            >
              Are you sure
            </Typography>
          </Box>
          <Box className="  mb-1 p-0 mt-6  ">
            {/* <Typography
              variant="body1"
              id="transition-modal-description"
              sx={{ mt: 2, textTransform: "capitalize", textAlign: "center" }}
            >
              You are not save this question
            </Typography> */}
            <Box sx={{ px: 2, display: "flex", alignItems: "center", mt: 1 }}>
              
              <Typography
                id="transition-modal-description"
                sx={{
                  textTransform: "capitalize",
                  fontSize: "15px",
                  fontWeight:"700",
                  ml: { xl: "9px", lg: "6px", sm: "4px" }
                }}
              >
                You have unsaved changes. 
              </Typography>
            </Box>
            <Box sx={{ px: 2, display: "flex", alignItems: "center", mt: 1 }}>
              <FiberManualRecordIcon sx={{ fontSize: "11px" }} />
              <Typography
                id="transition-modal-description"
                sx={{
                  textTransform: "capitalize",
                  fontSize: "12px",
                  ml: { xl: "9px", lg: "6px", sm: "4px" }
                }}
              >
                Please save your answer before moving to another question. If you modify or select a new answer, it must be saved before you can continue.
              </Typography>
            </Box>
            <Box sx={{ px: 2, display: "flex", alignItems: "center", mt: 1 }}>
              <FiberManualRecordIcon sx={{ fontSize: "11px" }} />
              <Typography
                id="transition-modal-description"
                sx={{
                  textTransform: "capitalize",
                  fontSize: "12px",
                  ml: { xl: "9px", lg: "6px", sm: "4px" }
                }}
              >
                Save your  answer and then you can traverse your question
              </Typography>
            </Box>
            <Box className="flex items-center justify-around px-2  mt-5 border-t py-2  border-gray-200">
              <button
                onClick={() => handleClose()}
                className="px-10 flex items-center justify-center uppercase py-1  border border-[#2563eb] hover:bg-blue-600 transition-all duration-500 hover:text-white "
              >
                Okay
              </button>
             
            </Box>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default QuestionSaveAlert;
